import Vue from 'vue'
import VueRouter from 'vue-router'
import paths from './paths';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import { RouteProtect } from './routeProtect'
import store from '../store'

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: paths
});

// router gards
router.beforeEach((to, from, next) => {
  NProgress.start();

  if (to.name === 'Root' || to.path === "/")
    NProgress.done();
  next();
});

router.afterEach(() => {
  NProgress.done();
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (localStorage.getItem('token')) {
      next();
      return
    }
    next({
      path: '/login',
    });
  } else {
    next()
  }
});

const rp = new RouteProtect(router, store);
router.beforeEach((to, from, next) => rp.resolve(to, from, next));

export default router;
